namespace('compass.hotel');

compass.requireLib('compass.util.format');

compass.hotel.HotelInventoryMatrixPopupWidget = compass.defineWidget( function HotelInventoryMatrixPopupWidget(options) {
	
	var d = jQuery.dom;
	var _settings = options;
	var availData = options.availData;
	var hotelsFiltered = options.hotelsFiltered;
	var availFiltered = [];
	var matrixData = options.matrixData;
	var _viewPort = $('#viewport');
	var _totalAvailCount = matrixData.totalAvailCount();
	var matrixDataArray = matrixData.as2DArray();

	var _shortDateFormat = (function() {
		var df = compass.util.dateFormatter('ddd');
		var shortDateFormatter = _settings.shortDateFormatter;
		return function(dateStr) {
			var formattedDate = df(compass.util.parse.ISODateParser(dateStr)) + ' ' + shortDateFormatter(compass.util.parse.ISODateParser(dateStr));
			return formattedDate;
		};
	})();
	
	this.render = ( function HotelInventoryMatrix_render(){
        var dialog = jQuery.dom.dialog( {

        	onDialogReady:function(_dialog){
        		var _dialogWindow = _dialog.find('.dialogWindow');
	        	var _tableWrapper = _dialogWindow.find('.compassExternalTable').not('.duplicateHeaderTable');
						var _duplicateTableWrapper = _dialogWindow.find('.compassExternalTable.duplicateHeaderTable');

		        var wrapper = _tableWrapper.find('.tableOverflowWrapper');
						var headerWrapper = _duplicateTableWrapper.find('.tableOverflowWrapper');
	        	var scrollBar = wrapper.find('.scrollBar');
	        	var _columns = headerWrapper.find('th').length - 3; //total number of scrollable cols
						var maxVisibleScrollableCols = 8; //viewport width in columns
						var _offset = 0;
						var scrollableColWidth = 53;
	        	var maxScroll = _columns > 8 ? (_columns - maxVisibleScrollableCols) * scrollableColWidth : 0;
	        	var maxScrollCols = Math.floor( maxScroll / scrollableColWidth );

		        var position = matrixData.startIndex > maxScrollCols ? maxScrollCols : matrixData.startIndex;

        		setLinks();
        		setScrollHandlers();

        		_dialog.bind('dialogOpen', function(){
        			//ew @ this - Not sure why it needs so much time after the append for the DOM to be accessible
        			setTimeout( function(){
        				wrapper.scrollLeft(position * scrollableColWidth);
        				headerWrapper.scrollLeft(position * scrollableColWidth);
        			}, 200 );
        		} );

        		function setLinks(){

        			var _sortLinks = _dialogWindow.find('.duplicateHeaderTable .sortLink');
        			_sortLinks.each( function(i){
	        			$(this).activate( handleSortLinks );

	        			function handleSortLinks(){
	        				_sortLinks.unbind('click'); //Not sure this is necessary but cleaning up to be safe.

	        				var doAscending = true;
	        				if( $(this).hasClass('sortedAscending') ){
	        					doAscending = false;
	        				}

	        				var newGridData = matrixData.sortBy( matrixData.mapCols(i), doAscending ).as2DArray();
	        				_tableWrapper.html(_buildMatrixTable(newGridData).html());
									// reset the wrapper value after rebuilding the table
									wrapper = _tableWrapper.find('.tableOverflowWrapper');
									wrapper.scrollLeft(position * scrollableColWidth);
									
									_sortLinks.removeClass('sortedAscending sortedDescending');
	        				_sortLinks.eq(i).addClass( doAscending ? 'sortedAscending' : 'sortedDescending');

	        				setLinks();
	        				setScrollHandlers();
	        			}
	        		} );
        		}

		        function setScrollHandlers(){

							var leftScrollButton = _dialog.find('.leftScrollButton');
							var rightScrollButton = _dialog.find('.rightScrollButton');

			        _dialog.find('.leftScrollButton, .rightScrollButton').activate( function() {

				        var me = $(this);

			            if( ! me.hasClass('inactive') ){
				            direction = me.hasClass('rightScrollButton') ? 1 : -1;
				            position = position + direction;

				            if(position < 0){ position=0; }

				            if(position === 0){
				            	leftScrollButton.addClass('inactive');
				            } else {
				            	leftScrollButton.removeClass('inactive');
				            } 
										
										if( position >= (_columns - maxVisibleScrollableCols) ){
				            	rightScrollButton.addClass('inactive');
				            } else {
				            	rightScrollButton.removeClass('inactive');
				            }

				            wrapper.animate({ scrollLeft:position * scrollableColWidth });
				            headerWrapper.animate({ scrollLeft:position * scrollableColWidth });

									}

			        } );

							wrapper.scroll( function(){
								// scroll behavior must apply to wrapper and headerWrapper
								var scrollPos = $(this).scrollLeft();

								if(scrollPos === 0){ leftScrollButton.addClass('inactive'); }
								else { leftScrollButton.removeClass('inactive'); }

								if(scrollPos >= maxScroll){ rightScrollButton.addClass('inactive'); }
								else { rightScrollButton.removeClass('inactive'); }
							} );

							_dialog.find('tr').not('.headerBlock').activate( function(){
								var me = $(this);
								var hotelId = me.attr('data-hotel_id');
								var blockedRoomId = me.attr('data-blocked_room_id');
								
								var blockInfoRoute = 'blockInfo/' + hotelId + '/' + blockedRoomId;
								var gdsRoute = 'hotelInfo/' + hotelId;
								var route = blockedRoomId ? blockInfoRoute : gdsRoute;

								if(matrixData.startDate && matrixData.endDate) {
									route += '/' + matrixData.startDate + '/' + matrixData.endDate;
								} 
								
								if(options.roomsRequested){
									route += '/' + options.roomsRequested;
								}

								jQuery('#viewport').trigger(CompassEvents.Navigate, route);
							} );

							_dialog.find('td').not('.headerBlock > td').mouseover(function(){
								$(this.parentNode).addClass('active');
							} );

							_dialog.find('td').mouseout(function(){
								$(this.parentNode).removeClass('active');
							} );

						}
        	},

					modal : true,
					width : 960,
					classes:'HotelInventoryMatrixPopupWidget',
					contents : [
						d.h1({}, 'Nightly Availability'),
						_buildMatrixTable( matrixDataArray ),
						_buildMatrixHeaderTable( [matrixDataArray[0]] )
					],
					zIndex : 500
        } );
	});

	// this is a copy of the inventory matrix table that only contains the header row so it can be properly frozen
	// at the top of the modal as the user scrolls down through the list
	function _buildMatrixHeaderTable(data) {
		var dataColSpan = data.length-3;

		var matrixOptions = {

			rowFormatters:{
				defaultFormatter:function(rowData, cells){
					return d.tr({ 'data-hotel_id':rowData.hotelId, 'data-blocked_room_id': rowData.blockedRoomId }, cells );
				},
				'0':function(rowData, cells){
					return d.tr({className:'headerBlock'}, cells );
				}
			},

			wrapperAttributes:{
				className:'compassExternalTable duplicateHeaderTable'
			},

			headerFormatters:{
				defaultFormatter:function(cellData){
					var dateISO = compass.util.parse.ISODateParser(cellData);
					var formattedDate = dateISO.getFullYear() + '-' + (dateISO.getMonth() + 1) + '-' + dateISO.getDate();
					var shortDate = _shortDateFormat(formattedDate);
					var date = shortDate.replace(/\s/, "<br/>");
					return d.th( { className:'night' },
						d.span(date)
					);
				},
				'0':function(cellData){
					return d.th( { className:'hotelName fixedRowHeaderCol notranslate' },
						d.a( { className:'sortLink', href:'javascript:;' },
							cellData,
							d.span( { className:'fa-solid fa-sort'} )
						)
					);
				},
				'1':function(cellData){
					return d.th( { className:'distance fixedRowHeaderCol' },
						d.a( { className:'sortLink', href:'javascript:;'  },
							cellData,
							d.span( { className:'fa-solid fa-sort'} )
						)
					);
				},
				'2':function(cellData){
					return d.th( { className:'avgRate fixedRowHeaderCol notranslate' },
						d.a( { className:'sortLink', href:'javascript:;'  },
							[
								d.span( {},
									cellData[0],
									d.span( { className:'fa-solid fa-sort'} )
								),
								d.br(),
								d.span( cellData[1] )
							]
						)
					);
				}
			}
		};
		data.onlyHeaderContent = true;

		var table = jQuery.dom.div( matrixOptions.wrapperAttributes, 

			jQuery.dom.div( { className:'tableVertOverflowWrapper'},
				jQuery.dom.div( { className:'tableOverflowWrapper'},

					jQuery.dom.table( { className:'' },

						matrixOptions.rowFormatters[0]( data[0],
							_.map( data[0], function(el, idx){
								var headerCellFormatter = matrixOptions.headerFormatters[idx] || matrixOptions.headerFormatters.defaultFormatter;
								return headerCellFormatter(data[0][idx]);
							} )
						)
					)
				)
			)
		);
					
		return table;
	}

	function _buildMatrixTable(data){
		var dataColSpan = data[0].length-3;

		var matrixOptions = {

			rowFormatters:{
				defaultFormatter:function(rowData, cells){
					return d.tr({ 'data-hotel_id':rowData.hotelId, 'data-blocked_room_id': rowData.blockedRoomId }, cells );
				},
				'0':function(rowData, cells){
					return d.tr({className:'headerBlock'}, cells );
				},
				'gds':function(rowData){
					return d.tr({ 'data-hotel_id':rowData.hotelId },
						d.td( { className:'hotelName rowHeader fixedRowHeaderCol notranslate' }, 
		    			d.span( { className:'vertCentering'},
								d.span({className:'hotelNameContent'}, rowData[0][0])
		    			)
						),
						d.td( { className:'distance fixedRowHeaderCol' },
								d.span( { className:'vertCentering'},
									[
									d.span( Math.round(rowData[1][0] * 10) /10 ),
									d.br(),
									d.span( rowData[1][1] )
								]
							)
						),
						d.td( { className:'avgRate fixedRowHeaderCol notranslate' },
							d.span(rowData.gdsRate)
						),
						d.td( { className:'gdsAvailability', colspan: dataColSpan },
							'Web Rate: Click here to conduct your search'
						)
					);
				},
				'unavailableHeader':function(rowData) {
					return d.tr( {className:'headerBlock' },
						d.td( { className:'headerCell', colspan:3 },
							d.span( { class:'vertCentering' },
								d.h2( 'Additional Rooms' ),
								d.br(),
								d.span( 'May not meet all of your desired criteria' )
							)
						),
						d.td( { colspan: dataColSpan } )
					);
				}
			},

			wrapperAttributes:{
				className:'compassExternalTable'
			},

			// headers are in the duplicate table 
			headerFormatters:{
				defaultFormatter:function(cellData){
					return '';
				}
			},
			contentFormatters: {

				defaultFormatter:function(cellData){
					if(cellData < 0 ){ cellData = 0; }
					return d.td( {}, d.span( {}, cellData ) );
				},

				'0':function(cellData){
		    		var cell = d.td( { className:'hotelName rowHeader fixedRowHeaderCol notranslate' },
		    			d.span( { className:'vertCentering'},
			    			[
			    				d.span({className:'hotelNameContent'}, cellData[0]),
			    				d.br(),
			    				d.span({className:'blockName'}, cellData[1])
			    			]
		    			)
		    		);
		    		return cell;
		    	},
				'1':function(cellData){
					return d.td( { className:'distance fixedRowHeaderCol' },
		    			d.span( { className:'vertCentering'},
		    				[
								d.span( {},
									Math.round(cellData[0] * 10) /10
								),
								d.br(),
								d.span( {}, cellData[1] )
							]
						)
					);
				},
				'2':function(cellData){
					return d.td( { className:'avgRate fixedRowHeaderCol notranslate' },
						d.span( {},
							 !Number.isNaN(Math.ceil(cellData * 100) / 100) ? matrixData.localization.currencySymbol + Math.ceil(cellData * 100) / 100 : 'TBD'
						)
					);
				}
			}
		};

		// if there are unavailable rooms blocks in the matrix
		if( _totalAvailCount !== data.length-1 ){
			// number of available rooms + 1 due to the header being a row in the table
			var unavailableHeaderRowIndex = _totalAvailCount + 1;
			var unavailableHeaderRow = [];
			unavailableHeaderRow.overrideFormatter = 'unavailableHeader';
			data.splice(unavailableHeaderRowIndex, 0, unavailableHeaderRow);
		}

		// Formatters in matrixOptions (headerFormatters, rowFormatters, and contentFormatters) take in the row or cell content
		// as the input and return the row dom.js will insert into the table.
		var table = jQuery.dom.div( matrixOptions.wrapperAttributes, 

			jQuery.dom.div( { className:'tableVertOverflowWrapper'},
				jQuery.dom.div( { className:'tableOverflowWrapper'},

					jQuery.dom.table( { className:'' },

						matrixOptions.rowFormatters[0]( data[0],
							_.map( data[0], function(el, idx){
								var headerCellFormatter = matrixOptions.headerFormatters[idx] || matrixOptions.headerFormatters.defaultFormatter;
								return headerCellFormatter(data[0][idx]);
							} )
						),

						jQuery.dom.tbody( { className:'scrollable' },
							_.map( data, function(dataRow, idx){
								if( idx === 0){ return ''; }
								var rowFormatter;
								var row;

								// An override formatter is required for special rows like GDS and the unavailable header, which cannot
								// be referred to by it's position (idx) in the array.
								if(dataRow.overrideFormatter) {
									rowFormatter = matrixOptions.rowFormatters[dataRow.overrideFormatter];
								} else {
									rowFormatter = matrixOptions.rowFormatters[idx] || matrixOptions.rowFormatters.defaultFormatter;
								}

								row = rowFormatter(dataRow, _.map( dataRow, function(cell, idx){
									var formatCell = matrixOptions.contentFormatters[idx] || matrixOptions.contentFormatters.defaultFormatter;
									return formatCell(cell);
								}));

								return row;
							})
						)
					)
				) //end table overflow wrapper
			), //end vert overflow wrapper

				jQuery.dom.button( { className:'leftScrollButton inactive' },
					jQuery.dom.div( { className:'scrollButtonLabel' },
						jQuery.dom.i( { className:'fa-regular fa-circle-chevron-left'} )
					)
				),
				jQuery.dom.button( { className:'rightScrollButton' },
					jQuery.dom.div( { className:'scrollButtonLabel' },
						jQuery.dom.i( { className:'fa-regular fa-circle-chevron-right'} )
					)
				)

		);

		return table;
	}

}, {
	hotelsFiltered:null,
	matrixData:null,
	roomsRequested:0
} );
